export const enum Roles {
  Viewer = 'viewer',
  Author = 'author',
  LocalProjectOwner = 'campaign-owner',
  GlobalProjectOwner = 'global-project-owner',
  ZoneManager = 'label-manager',
  GlobalManager = 'global-manager',
  SpaceMember = 'space-member',
  SpacePO = 'space-project-owner',
  SpaceManager = 'space-manager',
  Admin = 'admin',
}
